import React from 'react';
import { Heart, Globe, Users, UserCheck } from 'lucide-react';

const DashboardStatsCards = ({ stats, weddingCount, weddingLimit }) => {
  const isUnlimited = weddingLimit === -1;
  const limitLabel = isUnlimited ? 'Unlimited' : weddingLimit;
  const progress = isUnlimited ? 0 : Math.round((weddingCount / weddingLimit) * 100);

  const cards = [
    {
      label: 'Total Weddings',
      value: `${weddingCount} / ${limitLabel}`,
      progress: isUnlimited ? undefined : progress,
      icon: Heart,
    },
    {
      label: 'Published',
      value: stats?.published_weddings?.toString() || '0',
      icon: Globe,
    },
    {
      label: 'Total RSVPs',
      value: stats?.total_rsvps?.toLocaleString() || '0',
      subtitle: 'Responses across all weddings',
      icon: Users,
    },
    {
      label: 'Confirmed Guests',
      value: stats?.total_confirmed?.toLocaleString() || '0',
      subtitle: stats?.total_rsvps
        ? `${Math.round((stats.total_confirmed / stats.total_rsvps) * 100)}% confirmation rate`
        : null,
      subtitleColor: 'text-green-600',
      icon: UserCheck,
    },
  ];

  return (
    <section className="grid grid-cols-1 md:grid-cols-4 gap-6">
      {cards.map((card) => (
        <div
          key={card.label}
          className="p-5 rounded-sm relative overflow-hidden bg-white"
          style={{
            border: '1px solid rgba(212,175,55,0.4)',
            boxShadow: '0 4px 20px rgba(184,134,11,0.08)',
          }}
        >
          <div className="flex justify-between items-start mb-4">
            <div className="text-[#54626F] text-[10px] uppercase tracking-[0.2em] font-bold">
              {card.label}
            </div>
            <card.icon className="w-5 h-5 text-[#C5A059]" />
          </div>
          <p className="text-3xl font-light text-[#36454F]" style={{ fontFamily: "'Lato', sans-serif" }}>
            {card.value}
          </p>
          {card.progress !== undefined && (
            <div className="w-full bg-[#F3F4F6] h-1 rounded-full overflow-hidden mt-3">
              <div
                className={`h-full rounded-full transition-all duration-500 ${
                  card.progress >= 100 ? 'bg-red-500' : 'bg-[#D4AF37]'
                }`}
                style={{ width: `${Math.min(card.progress, 100)}%` }}
              />
            </div>
          )}
          {card.subtitle && (
            <p className={`text-[10px] mt-2 font-bold uppercase tracking-wider ${card.subtitleColor || 'text-[#54626F]'}`}>
              {card.subtitle}
            </p>
          )}
        </div>
      ))}
    </section>
  );
};

export default DashboardStatsCards;
